<div class="quote-step6-quote-step3-1 animation-fadein" [ngClass]="rootClassName">
  <div class="quote-step6-desktop-menu2-default">
    <div class="quote-step6-component1">
      <span class="quote-step6-text"><span>By BAC Financial</span></span>
      <div class="quote-step6-group"></div>
      <div class="quote-step6-group1"></div>
    </div>
    <div class="quote-step6-frame77">
      <span class="quote-step6-text02"><span>Nosotros</span></span>
      <span class="quote-step6-text04"><span>BENEFICIOS</span></span>
      <span class="quote-step6-text06"><span>Planes</span></span>
      <span class="quote-step6-text08"><span>ASEGURADOS</span></span>
    </div>
  </div>
  <span class="quote-step6-text10 DesK,P4,Regular,16">
    <span>
      Por favor confirma tus datos antes de proceder con el pago.
      <span [innerHTML]="rawjde1"></span>
    </span>
  </span>
  
  <div class="quote-step6-container">
    <!-- <div class="quote-step6-frame566">
      <div class="quote-step6-frame274">
        <div class="quote-step6-frame1095">
          <div class="quote-step6-frame168">
            <div class="quote-step6-frame165">
              <span class="quote-step6-text12 Desk,P4,Bold.14">
                <span>Nombres Completos*</span>
              </span>
            </div>
            <div class="quote-step6-frame1681">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder"
                class="quote-step6-input"
              />
            </div>
          </div>
          <div class="quote-step6-frame173">
            <div class="quote-step6-frame1651">
              <span class="quote-step6-text14 Desk,P4,Bold.14">
                <span>Apellidos del titular</span>
              </span>
            </div>
            <div class="quote-step6-frame169">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder1"
                class="quote-step6-input1"
              />
            </div>
          </div>
        </div>
        <div class="quote-step6-frame1096">
          <div class="quote-step6-frame174">
            <div class="quote-step6-frame1652">
              <span class="quote-step6-text16 Desk,P4,Bold.14">
                <span>País</span>
              </span>
            </div>
            <div class="quote-step6-frame1691">
              <input
                type="text"
                [attr.placeholder]="inputplaceholder2"
                class="quote-step6-input2"
              />
            </div>
          </div>
          <div class="quote-step6-frame1731">
            <div class="quote-step6-frame1653">
              <span class="quote-step6-text18 Desk,P4,Bold.14">
                <span>Número de Pasaporte</span>
              </span>
            </div>
            <div class="quote-step6-frame1691">
              <input
                type="text"
                placeholder="7423 5734"
                class="quote-step6-input2"
              />
            </div>
            
          </div>
        </div>
      </div>
    </div> -->
    <div class="form-section mt-0">
      <div class="form-left-section form-itams">
        <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
      </div>
      <div class="p-5 form-general-style ng-untouched ng-pristine ng-invalid">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <input type="text" class="form-control form-input input-form-full-space"
                onclick="this.setAttribute('value', this.value);" value="">
              <label for="firstName" class="form-input-label">Nombres Completos*</label>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <input type="text" class="form-control form-input input-form-full-space"
                onclick="this.setAttribute('value', this.value);" value="">
              <label for="Apellidos del titular" class="form-input-label">Apellidos del titular</label>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <input type="text" class="form-control form-input input-form-full-space"
                onclick="this.setAttribute('value', this.value);" value="">
              <label for="País" class="form-input-label">País</label>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <input type="text" class="form-control form-input input-form-full-space"
                onclick="this.setAttribute('value', this.value);" value="">
              <label for="Número de Pasaporte" class="form-input-label">Número de Pasaporte</label>
            </div>
          </div>
        </div>
        <div class="form-group mb-0"><button type="submit" (click)="nextStep()"
            class="btn btn-primary continue-btn-steps py-3">Continuar Compra</button></div>
      </div>
      <div class="form-right-section form-itams">
        <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
      </div>
      <a href="javascript:void(0)" class="back-link">
        < Atrás</a>
    </div>
    <!-- <div class="quote-step6-frame478">
      <div class="quote-step6-group1131">
        <button class="quote-step6-frame275" (click)="nextStep()">
          <span class="quote-step6-text23 Desk,P4,Bold.14">
            <span>Continuar Compra</span>
          </span>
        </button>
      </div>
      <button class="quote-step6-text25 DesK,P4,Regular,16" (click)="prevStep()">
        <span>&lt; Paso anterior</span>
      </button>
    </div> -->
  </div>
  <div class="quote-step6-frame456">
    <span class="quote-step6-text27 Mob,P4,Intro,Light,10">
      <span>Cotizar</span>
    </span>
    <span class="quote-step6-text29 Mob,P4,Intro,Light,10">
      <span>Customizar</span>
    </span>
    <span class="quote-step6-text31 Mob,P6-Intro-Bold">
      <span>Contacto</span>
    </span>
    <span class="quote-step6-text33 Mob,P4,Intro,Light,10">
      <span>Pago</span>
    </span>
    <span class="quote-step6-text35 Mob,P4,Intro,Light,10">
      <span>Certificado</span>
    </span>
    <div class="quote-step6-progressbar"></div>
    <div class="quote-step6-progressbar1"></div>
    <div class="quote-step6-progressbar2"></div>
    <img
      [attr.alt]="ellipse25alt"
      [attr.src]="ellipse25src"
      class="quote-step6-ellipse25"
    />
    <img
      [attr.alt]="vectoralt"
      [attr.src]="vectorsrc"
      class="quote-step6-vector"
    />
    <img
      [attr.alt]="ellipse25alt1"
      [attr.src]="ellipse25src1"
      class="quote-step6-ellipse251"
    />
    <img
      [attr.alt]="vectoralt1"
      [attr.src]="vectorsrc1"
      class="quote-step6-vector1"
    />
    <img
      [attr.alt]="ellipse25alt2"
      [attr.src]="ellipse25src2"
      class="quote-step6-ellipse252"
    />
    <img
      [attr.alt]="vectoralt2"
      [attr.src]="vectorsrc2"
      class="quote-step6-vector2"
    />
    <img
      [attr.alt]="ellipse25alt3"
      [attr.src]="ellipse25src3"
      class="quote-step6-ellipse253"
    />
    <img
      [attr.alt]="vectoralt3"
      [attr.src]="vectorsrc3"
      class="quote-step6-vector3"
    />
    <img
      [attr.alt]="ellipse25alt4"
      [attr.src]="ellipse25src4"
      class="quote-step6-ellipse254"
    />
    <img
      [attr.alt]="vectoralt4"
      [attr.src]="vectorsrc4"
      class="quote-step6-vector4"
    />
  </div>
</div>
